
import * as React from "react"
import { Location } from '@reach/router';
import wave from "images/wave.png"

import FooterNavigation from "global/FooterNavigation"
import FooterSocials from "global/FooterSocials";
import FooterLogos from "global/FooterLogos";

import Link from "components/Link"

import DataProvider from 'providers/data';

const FooterHandler = props => {
	return (
		<>
			<footer className="footer">
				<div className="upper-footer">
					<div className="grid-container">
						<div className="grid-x grid-padding-x">
							<div className="cell small-10 medium-12 flx small-text-center">
								<FooterNavigation />
								<FooterSocials />
							</div>
						</div>
					</div>
					<FooterLogos/>
				</div>
				<img src={wave} alt="" />
				<div className="lower-footer">
					<div className="grid-container">
						<div className="grid-x grid-padding-x">
							<div className="cell small-12 medium-12 large-6 text-left small-text-center">
								25777 US Highway 331 South<br/>
								Santa Rosa Beach, Florida 32459<br/>
								<a href="tel:8008226877">(800) 822-6877</a> or <a href="tel:8502671216">(850) 267-1216</a>
							</div>
							<div className="cell small-12 medium-12 large-6 text-right small-text-center">
								<span className="legalese">
									<Link to={`/privacy-terms/`}>Privacy & Terms of Use</Link>
									<br />
									All rights reserved.
								</span>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}

const Footer = props => {
	return (
		<Location>
			{locationProps => <DataProvider liveRefresh={true} type="ContentPage" apiParams={{ uri: locationProps.location.pathname }}><FooterHandler {...props} location={locationProps.location} /></DataProvider>}
		</Location>
	)
}

export default Footer
